(function() {
    'use strict';

    angular.module('app.puestos', []);
})();
